import React from 'react';
import { Grid, TextField, InputAdornment } from '@mui/material';
import BlogCard from '../BlogCard';
import SkeletonBlog from '../skeletonBlog/SkeletonBlog';
import SubscribeEmail from '../subscribe/SubscribeEmail';
import {
    BlogSectionWrapper,
    BlogSectionHero,
    BlogSectionHeroTitle,
    BlogSectionHeroSubtitle,
    BlogSectionPostsGrid,
    BlogSectionBlogsGrid,
    BlogSectionSidebar,
    BlogSectionSearchIcon,
    BlogSectionPagination,
} from './styles';

interface BlogItem {
    id: string;
    name: string;
    featuredImage: string;
    publishDate: string;
}

interface BlogSectionProps {
    loading: boolean;
    blogs: BlogItem[];
    search: string;
    setSearch: (search: string) => void;
    email: string;
    setEmail: (email: string) => void;
    setOffset: (offset: number) => void;
    totalPage: number;
}

const BlogSection = ({
    loading,
    blogs,
    search,
    setSearch,
    email,
    setEmail,
    setOffset,
    totalPage,
}: BlogSectionProps) => {

    const paginationHandler = (_: React.ChangeEvent<unknown>, value: number): void => {
        setOffset(value === 0 ? 0 : value - 1);
    };

    return (
        <BlogSectionWrapper>
            <BlogSectionHero>
                <BlogSectionHeroTitle>SecurSpace Blog</BlogSectionHeroTitle>
                <BlogSectionHeroSubtitle>It's simple and secure</BlogSectionHeroSubtitle>
            </BlogSectionHero>
            <div className='ss-blog-container'>
                <BlogSectionPostsGrid container wrap='wrap'>
                    <Grid item sm={9} md={9}>
                        <BlogSectionBlogsGrid container>
                            {loading
                                ? [...Array(12).keys()].map((_, index) => <SkeletonBlog key={index} />)
                                : blogs?.map((item) => <BlogCard key={item.id} {...item} />)
                            }
                        </BlogSectionBlogsGrid>
                    </Grid>
                    <BlogSectionSidebar item sm={3} md={3}>
                        <TextField
                            type='text'
                            value={search}
                            onChange={(e) => { setSearch(e.target.value); setOffset(0); }}
                            placeholder='Search'
                            className='ss-blog-input'
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <BlogSectionSearchIcon
                                            src="https://static.secur.space/icons/search.png"
                                            alt="Search"
                                        />
                                    </InputAdornment>
                                ),
                            }}
                            fullWidth
                            variant="standard"
                        />
                        <SubscribeEmail email={email} setEmail={setEmail} />
                    </BlogSectionSidebar>
                </BlogSectionPostsGrid>
                <BlogSectionPagination onChange={paginationHandler} count={totalPage} variant="outlined" color='primary' />
            </div>
        </BlogSectionWrapper>
    );
};

export default BlogSection;
